export const contactInfo = {
    phone: "(385) 222-0109",
    email: "oe@oealternatives.com",
    address: "1591 N Main St Suite B, Layton, UT 84041",
};